module.exports = __webpack_public_path__ + "img/added-service-unit-05.c8755651.png";